var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"team-icon-wrapper",class:{'small': _vm.small}},[(_vm.getURL(_vm.team))?_c('img',{staticClass:"team-icon",class:{'small': _vm.small},attrs:{"src":_vm.getURL(_vm.team)}}):_c('div',{staticClass:"team-icon",class:{
      'default-team-icon': _vm.sideMenu ? _vm.selected : true,
      'not-selected-team-icon': _vm.sideMenu ? !_vm.selected : false,
      'small': _vm.small,
    }},[_c('p',[_vm._v("\n      "+_vm._s(_vm.firstLetter(_vm.team.name))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }